import React from 'react';

const Partners: React.FC = () => {
  // Technology Partners - Common IT industry partners
  const partners = [
    {
      name: 'Microsoft',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Microsoft_logo.svg/512px-Microsoft_logo.svg.png',
      type: 'Gold Partner'
    },
    {
      name: 'Google Cloud',
      logo: 'https://www.gstatic.com/devrel-devsite/prod/v0e0f589edd85502a40d78d7d0825db8ea5ef3b99ab4070381ee86977c9168730/cloud/images/cloud-logo.svg',
      type: 'Partner'
    },
    {
      name: 'Amazon Web Services',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Amazon_Web_Services_Logo.svg/512px-Amazon_Web_Services_Logo.svg.png',
      type: 'Partner'
    },
    {
      name: 'Dell Technologies',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Dell_Logo.svg/512px-Dell_Logo.svg.png',
      type: 'Partner'
    },
    {
      name: 'HP',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/HP_logo_2012.svg/480px-HP_logo_2012.svg.png',
      type: 'Partner'
    },
    {
      name: 'Cisco',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Cisco_logo_blue_2016.svg/512px-Cisco_logo_blue_2016.svg.png',
      type: 'Partner'
    },
    {
      name: 'Lenovo',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Lenovo_logo_2015.svg/512px-Lenovo_logo_2015.svg.png',
      type: 'Partner'
    },
    {
      name: 'VMware',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Vmware.svg/512px-Vmware.svg.png',
      type: 'Partner'
    },
  ];

  return (
    <section id="partners" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-blue-600 font-semibold text-lg">Trusted Technology</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mt-2 mb-4">
            Our Partners
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            We partner with leading technology companies to deliver best-in-class solutions
            for our clients.
          </p>
        </div>

        {/* Microsoft Gold Partner Badge */}
        <div className="flex justify-center mb-12">
          <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl px-8 py-6 text-white flex items-center space-x-4">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Microsoft_logo.svg/512px-Microsoft_logo.svg.png"
              alt="Microsoft"
              className="h-12 bg-white p-2 rounded"
            />
            <div>
              <p className="text-sm text-blue-200">Authorized</p>
              <p className="text-xl font-bold">Microsoft Silver Certified Partner</p>
            </div>
          </div>
        </div>

        {/* Partners Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-6 flex items-center justify-center hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group"
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="h-12 md:h-16 object-contain filter grayscale group-hover:grayscale-0 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
